import React from "react";
import { Icon } from "@/shared/ui/Icon";
import { Center, Column } from "@/shared/ui/Blocks";

type SortDirection = "asc" | "desc";
interface SortArrowsProps {
  visible?: boolean;
  sort?: SortDirection;
  onSort?: (direction: SortDirection) => void;
}

function SortArrows(props: SortArrowsProps) {
  const { visible = true, sort, onSort = () => {} } = props;

  if (!visible) return null;

  return (
    <Column
      className="space-y-px justify-center items-center"
      onClick={() => onSort(sort === "asc" ? "desc" : "asc")}
    >
      <Icon
        icon="SortArrow"
        color={sort === "asc" ? "grey" : "lightGrey"}
        size="2xs"
      />
      <Icon
        icon="SortArrow"
        color={sort === "desc" ? "grey" : "lightGrey"}
        className="rotate-180"
        size="2xs"
      />
    </Column>
  );
}

export { SortArrows };
